// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2I-Cl","label":"Labeled_label__3_Px5","divider":"Labeled_divider__3nNOe"};